import React from "react";
import { GitHubLogoIcon, LinkedInLogoIcon, BackpackIcon} from "@radix-ui/react-icons";
import { Center } from "@react-three/drei";

const separatorStyle: React.CSSProperties = {
    width: 1,
    height: 60,
    background: '#8d393950',
    margin: `0 5px`,
    borderRadius: 1,
};

function openInNewTab(url: string): void {
  // Open the URL in a new tab
  const newTab = window.open(url, '_blank');
  
  // Optional: focus on the new tab if it opened successfully
  if (newTab) {
    newTab.focus();
  }
}

const AboutModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const primary = '#8d3939ff';

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
            <div role="dialog" aria-modal="true" aria-label="About project" style={{
                background: '#fff', width: 780, maxWidth: '96%', borderRadius: 12, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', overflow: 'hidden',
                display: 'flex', flexDirection: 'column', fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial'
            }}>
                <div style={{ display: 'flex', gap: 20, padding: 22 }}>
                    <div style={{ flex: '0 0 140px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ width: 120, height: 120, borderRadius: 12, background: primary, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 200, fontSize: 82 }}>
                            λ
                        </div>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                        <h2 style={{ margin: 0, color: primary }}>Lambda Studio IDE</h2>
                        <p style={{ margin: '8px 0 16px', color: '#333', lineHeight: 1.4 }}>Parametric simulation engine for designing and inspecting complex optical systems</p>

                        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                            <div style={{ minWidth: 190 }}>
                                <div style={{ fontSize: 12, color: '#777' }}>Project</div>
                                <div style={{ fontWeight: 500 }}>Optic Simulation Engine</div>
                                <div style={{ fontWeight: 500 }}>WebApp Frontend</div>
                                <div style={{ fontWeight: 500 }}>WebApp Backend</div>
                            </div>

                            <div style={{ minWidth: 110 }}>
                                <div style={{ fontSize: 12, color: '#777' }}>Version</div>
                                <div>0.4.9 (beta)</div>
                                <div>0.1.0 (beta)</div>
                                <div>0.1.0 (beta)</div>
                            </div>

                            <div style={{ minWidth: 140 }}>
                                <div style={{ fontSize: 12, color: '#777' }}>Author</div>
                                
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={separatorStyle} />
                                    <div style={{ marginLeft: 4, lineHeight: 1.4, fontSize: 14 }}>
                                        <div>PhD. Emiliano Jan</div>
                                    </div>
                                </div>
                            
                            </div>
                        </div>

                        <div style={{ marginTop: 18, borderTop: '1px solid #f3f3f3', paddingTop: 12 }}>
                            <h3 style={{ margin: '0 0 6px 0', fontSize: 14, color: '#444' }}>Description</h3>
                            <p style={{ margin: 0, color: '#555' }}> The software allows parametric simulations of optical components within an integrated programming environment (IDE). Tools are available to study and evaluate complex optical conditions. Each simulation is specifically defined by the user, with the goal of simulating only those aspects that are of interest.</p>
                        </div>

                        <div style={{ marginTop: 18, borderTop: '1px solid #f3f3f3', paddingTop: 12 , gap: 4, display: 'flex', flexWrap: 'wrap' }}>
                            <h3 style={{ margin: '0 0 6px 0', fontSize: 14, color: '#444' }}></h3>
                            <button style={{ background: primary, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, alignItems: 'center', cursor: 'pointer'}} onClick={() => {openInNewTab('https://www.linkedin.com/company/lambda-studio-ide/');}}>
                                <LinkedInLogoIcon style={{ verticalAlign: 'middle', marginRight: 4 }} /> Project LinkedIn
                            </button>

                            <button style={{ background: primary, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, alignItems: 'center', cursor: 'pointer' }} onClick={() => {openInNewTab('https://github.com/EmilianoJan/OpticStudioDev');}}>
                                <GitHubLogoIcon style={{ verticalAlign: 'middle', marginRight: 4 }} /> Github
                            </button>

                            <div style={{ width: 100}} />
                            <button style={{ background: primary, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, alignItems: 'center', cursor: 'pointer'}} onClick={() => {openInNewTab('https://www.linkedin.com/in/emiliano-jan/');}}>
                                <LinkedInLogoIcon style={{ verticalAlign: 'middle', marginRight: 4 }} /> Personal LinkedIn
                            </button>

                            <button style={{ background: primary, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, alignItems: 'center', cursor: 'pointer'}} onClick={() => {openInNewTab('https://emilianojan.com.ar/CV/indexEng.html');}}>
                                <BackpackIcon style={{ verticalAlign: 'middle', marginRight: 4 }} /> CV
                            </button>

                        </div>
                    </div>
                </div>

                <div style={{ borderTop: '1px solid #eee', padding: 14, display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={onClose} style={{ background: primary, color: '#fff', border: 'none', padding: '10px 16px', borderRadius: 8, cursor: 'pointer' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AboutModal;